import React from 'react';
import {Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Select from 'react-select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from '../../ApiFetcher';
import Utility from '../../Utility';
import PlantManagementUtility from "./PlantManagementUtility";

const styles = theme => ({
    select: {
        textAlign: 'left',
        margin: 'auto',
        color: theme.palette.text.primary,
        '& input': {
            font: 'inherit',
        },
        width: 'auto',
    },
    button: {
        margin: 'auto',
        width: '30%',
        marginTop: theme.spacing.unit * 8,
    },
    buttonDiv: {
        margin: 'auto',
        width: '100%',
    },
    circularProgress: {
        textAlign: 'center',
        marginTop: theme.spacing.unit * 5,
    },
    form: {
        textAlign: 'center',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
});

export class SelectConstructionPlan extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            sceneList: [],
            workPlace: null,
            isWaitGetSceneList: false,
        };

        this.handleResponse = this.handleResponse.bind(this);
        this.getItemList = this.getItemList.bind(this);
        this.onChangeWorkPlace = this.onChangeWorkPlace.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitCsvIDClipBoard = this.handleSubmitCsvIDClipBoard.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('工事計画CSV選択画面', true);
        }
    }

    componentDidMount(){
        this.setState({isWaitGetSceneList: true}, () => {
            ApiFetcher.getSceneList(this.props.cookies.get('token'), this.handleResponse);
        });
    }

    handleResponse(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.sceneNameList)){
            // 想定されるエラーは以下の通り.
            // + DBに工事計画CSVが存在しない
            // + トークン期限切れ
            // 画面が成立しないのでトップ画面に戻す.
            alert('工事計画CSVの取得に失敗したためトップ画面に戻ります。');
            this.props.history.push(this.props.backPath);
        }
        else{
            // 現場名一覧のソート.
            let sortSceneList = PlantManagementUtility.sortSceneList(responseJson.result.sceneNameList);
            this.setState({sceneList: sortSceneList, isWaitGetSceneList: false});
        }
    }

    getItemList(){
        return this.state.sceneList.map(scene => ({
            value: scene.csvId,
            label: scene.sceneName + "(" + scene.uploadDatetime + ")",
        }));
    }

    onChangeWorkPlace = (e) => {
        this.setState({workPlace: e});
    }

    handleSubmit = () => {
        const path = this.props.nextPath + '?csvId=' + this.state.workPlace.value;
        this.props.history.push(path);
    }

    handleSubmitCsvIDClipBoard = () => {
        const valueToCopy = this.state.workPlace.value;
        navigator.clipboard.writeText(valueToCopy);
    }

    render(){
        if(this.state.isWaitGetSceneList){
            // 応答待ち表示.
            return (
                <div className={this.props.classes.circularProgress}>
                    <CircularProgress/>
                </div>
            );
        }else if(this.state.sceneList.length === 0){
            return (                
                <div className={this.props.classes.form}>
                    <div>工事計画CSVが1件もありません。</div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                </div>
            );
        }else{
            return (
                <div className={this.props.classes.form}>
                    <div className={this.props.classes.select}>
                        <Grid container spacing={8}>
                            <Grid item xs={10}>
                                <Select
                                    placeholder="現場名を選択または入力して下さい"
                                    options={this.getItemList()}
                                    value={this.state.workPlace}
                                    onChange={this.onChangeWorkPlace}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button disabled={Utility.isNullOrUndefined(this.state.workPlace)} variant="contained" color="primary" className={this.props.classes.buttonDiv} onClick={this.handleSubmit}>
                                    取込
                                </Button>
                                {/* KECユーザーのみ表示 */}
                                {Utility.isKecRole(this.props.cookies.get('role')) && (
                                    <Button disabled={Utility.isNullOrUndefined(this.state.workPlace)} variant="contained" color="primary" style={{ marginTop: 16 }} className={this.props.classes.buttonDiv} onClick={this.handleSubmitCsvIDClipBoard}>
                                        CSVIDをクリップボードにコピー
                                    </Button>
                                    )
                                }
                            </Grid>
                        </Grid>
                    </div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                </div>
            );
        }
    }
}

export default withStyles(styles)(SelectConstructionPlan);
